import React, { ChangeEvent } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { styled } from '@mui/system';
import CalendarIcon from '@mui/icons-material/CalendarTodayRounded';
import { useTranslation } from 'react-i18next';
import ICleaningSchedule from '../../../models/cleaningSchedule';

const ScheduleWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '8em',
    width: '100%',
});

const Text = styled(Typography)({
    fontSize: '0.8em',
    fontWeight: 600,
    margin: '.5em',
});

const Wrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'transparent',
    borderRadius: 5,
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
});

const LeftWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 0.5,
});

const RightWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '0.5em',
    flex: 0.5,
});

interface LocalCleaningProps {
    localCleaning: ICleaningSchedule;
    setLocalCleaning: (localCleaning: ICleaningSchedule) => void;
}

const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

const LocalCleaning = ({ localCleaning, setLocalCleaning }: LocalCleaningProps) => {
    const { t } = useTranslation();
    const onChange = (dayKey: string) => (e: ChangeEvent<HTMLInputElement>) => {
        setLocalCleaning({
            ...localCleaning,
            [dayKey]: Number(e.target.value),
        });
    };

    return (
        <ScheduleWrapper>
            {daysOfWeek.map(dayKey => (
                <Wrapper key={dayKey}>
                    <LeftWrapper>
                        <CalendarIcon />
                        <Text>{t(`schedule.${dayKey}`)}</Text>
                    </LeftWrapper>
                    <RightWrapper>
                        <TextField
                            type="number"
                            value={localCleaning[dayKey]}
                            onChange={onChange(dayKey)}
                        />
                    </RightWrapper>
                </Wrapper>
            ))}
        </ScheduleWrapper>
    );
};

export default LocalCleaning;
